export default __webpack_public_path__ + "static/media/bomcorte.e7aaf7e0.png";